import { tableOfContents, add_link_hover } from './utils.js';

jQuery(document).ready(function () {
  console.log("challenges.js loaded");
  tableOfContents("h2");

  var headers = jQuery("#page_contents").find("h2");
  headers.each((index, element) => {
    add_link_hover(element);
  });
});